import type { Decamelized } from 'humps';

import { PAYEX_URL } from 'constants/config';
import type { Order } from 'models/order';
import { fetchJson } from 'utils/fetchJson/fetchJson';

const extraFees = {
  add: (data: Decamelized<Order>) => {
    const path = `${PAYEX_URL}/extra_fees`;
    const options = {
      method: 'POST',
      body: JSON.stringify(data),
    };

    return fetchJson(path, options);
  },
};

export { extraFees };
